import { Icon, type INamedIconProps } from '@public/components/Icon/Icon';

export const UndecidedIcon = ({ ...props }: INamedIconProps) => (
  <Icon
    height="12"
    iconName="Undecided"
    viewBox="0 0 50 51"
    y="25%"
    {...props}
  />
);
